export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: '51heiliao',
    name: '51黑料',
    description: '51黑料网最新地址入口，聚合51黑料最新内容与热门吃瓜资讯，每日更新最全的黑料51内容合集',
    icon: 'ri-fire-line',
  },
  {
    slug: '91heiliao',
    name: '91黑料',
    description: '91黑料网入口导航，提供91黑料吃瓜最新爆料、热门视频与社区讨论，一站式91黑料内容平台',
    icon: 'ri-flashlight-line',
  },
  {
    slug: '17heiliao',
    name: '17黑料',
    description: '17黑料网最新地址，汇集17黑料吃瓜视频、热门事件追踪与深度分析，实时更新17黑料动态',
    icon: 'ri-eye-line',
  },
  {
    slug: '718heiliao',
    name: '718黑料合集',
    description: '718黑料合集专区，整合全网黑料718热门内容，提供718黑料合集入口与精选资源推荐',
    icon: 'ri-stack-line',
  },
  {
    slug: 'chiigua',
    name: '吃瓜爆料',
    description: '最新吃瓜爆料专区，追踪网络热点事件，提供第一手内幕消息与独家爆料内容',
    icon: 'ri-emotion-line',
  },
  {
    slug: 'redian',
    name: '热点追踪',
    description: '实时热点追踪栏目，紧跟时事动态，深度解读网络热门话题与社会现象',
    icon: 'ri-bar-chart-line',
  },
];